import React from "react";
import { withTranslation } from "react-i18next";
import MarkDownViewer from "../../../../components/markdownViewer/MarkDownViewer";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";




const DescriptionDialog = props => {
  const { t } = props;
  let descriptionText = props.description ? props.description[props.lang || 'en'] : undefined

  return (
    <BaseDialog
      show={props.show}
      onHide={props.onHide}
      title={t("Modules.DescriptionDialog.Title")}
      body={(<div>
        <MarkDownViewer
            lang={props.lang}
            defaultlanguage="en"
            text={descriptionText ? props.description : {en: t('Modules.DescriptionDialog.NoDescription')}}
          />
      </div>)} />
  );
}

export default withTranslation()(DescriptionDialog);
